import { motion } from 'framer-motion';

const footerLinks = {
  companies: [
  { name: 'Haveli', href: '#companies' },
  { name: 'Horizon', href: '#companies' },
  { name: 'Kritam', href: '#companies' },
  { name: 'HANS', href: '#companies' },
  { name: 'Hifazat', href: '#companies' },
  { name: 'Hemraj Hotels', href: '#companies' }],

  technology: [
  { name: 'Horizon CodeWorks', href: '#technology' },
  { name: 'Horizon App', href: '#technology' },
  { name: 'Hemraj One', href: '#technology' }],

  fashion: [
  { name: 'Hunar', href: '#fashion' },
  { name: 'Vastram', href: '#fashion' },
  { name: 'RAGS', href: '#fashion' },
  { name: 'Heer', href: '#fashion' },
  { name: 'Huzur', href: '#fashion' }],

  culture: [
  { name: 'Hemraj Talkies', href: '#fashion' },
  { name: 'Hemraj Screen', href: '#fashion' }]

};

export const Footer = () => {
  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer
      data-testid="main-footer"
      className="bg-[#1A1A1A] text-[#F9F6F0] py-16 lg:py-24">

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        {/* Top Section */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 mb-16 lg:mb-24">
          {/* Brand */}
          <div className="lg:col-span-4">
            <motion.h2
              className="font-heading text-3xl lg:text-4xl font-light tracking-tight mb-6"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}>

              HEMRAJ<br />GRANDSONS
            </motion.h2>
            <p className="text-sm text-[#F9F6F0]/60 leading-relaxed max-w-xs">
              Building the Environments Where Life Happens. A vertically integrated Indian 
              group creating spaces for generations.
            </p>
          </div>

          {/* Links */}
          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <p className="overline mb-4 !text-[#E7E7E7]">Core</p>
              <ul className="space-y-2">
                {footerLinks.companies.map((link) =>
                <li key={link.name}>
                    <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#F9F6F0]/70 hover:text-[#C5A880] transition-colors">

                      {link.name}
                    </button>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <p className="overline mb-4 !text-[#E7E7E7]">Technology</p>
              <ul className="space-y-2">
                {footerLinks.technology.map((link) =>
                <li key={link.name}>
                    <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#F9F6F0]/70 hover:text-[#C5A880] transition-colors">

                      {link.name}
                    </button>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <p className="overline mb-4 !text-[#E7E7E7]">Fashion</p>
              <ul className="space-y-2">
                {footerLinks.fashion.map((link) =>
                <li key={link.name}>
                    <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#F9F6F0]/70 hover:text-[#C5A880] transition-colors">

                      {link.name}
                    </button>
                  </li>
                )}
              </ul>
            </div>

            <div>
              <p className="overline mb-4 !text-[#E7E7E7]">Culture</p>
              <ul className="space-y-2">
                {footerLinks.culture.map((link) =>
                <li key={link.name}>
                    <button
                    onClick={() => scrollToSection(link.href)}
                    className="text-sm text-[#F9F6F0]/70 hover:text-[#C5A880] transition-colors">

                      {link.name}
                    </button>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#F9F6F0]/10 mb-8" />

        {/* Bottom Section */}
        <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-[#F9F6F0]/40">
            © {new Date().getFullYear()} Hemraj Grandsons. All rights reserved.
          </p>
          <div className="flex gap-6">
            <button className="text-xs text-[#F9F6F0]/40 hover:text-[#C5A880] transition-colors">
              Privacy Policy
            </button>
            <button className="text-xs text-[#F9F6F0]/40 hover:text-[#C5A880] transition-colors">
              Terms of Service
            </button>
          </div>
        </div>
      </div>
    </footer>);

};